import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { WidgetBaseComponent } from '../widget-base/widget-base.component';

@Component({
  selector: 'widget-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VideoComponent extends WidgetBaseComponent implements OnInit {
  iframe: any;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.iframe = JSON.parse(this.widget?.externalVideo) || '';
  }

  sanitizeHtml(rawHtml: string): SafeHtml {
    const withAutoplay = this._addAutoplay(rawHtml);
    return this.sanitizer.bypassSecurityTrustHtml(withAutoplay);
  }

  /** Adiciona autoplay=1&mute=1 ao src do iframe (YouTube e Vimeo) */
  private _addAutoplay(html: string): string {
    if (!html) return html;
    return html.replace(
      /(<iframe[^>]+src=")([^"]+)(")/gi,
      (_, open, src, close) => {
        const url = new URL(src);
        url.searchParams.set('autoplay', '1');
        url.searchParams.set('mute', '1'); // YouTube obriga mute para autoplay
        url.searchParams.set('autopause', '0'); // Vimeo
        return `${open}${url.toString()}${close}`;
      },
    );
  }
}
